<template>
<div class="results">
  <v-card class="records">
    <v-toolbar flat dense dark color="primary">
      <v-toolbar-title>Rekordy</v-toolbar-title>
    </v-toolbar>
    <v-layout justify-center row>
    <v-flex
      xs12
      sm12
      md12
      lg10
      xl8>
      <records
        @set-distance="setDistance"
      ></records>
    </v-flex>
    </v-layout>
    <v-divider class="mt-4 mb-2"/>
    <v-toolbar flat dense dark color="primary">
      <v-toolbar-title>Progres wyników</v-toolbar-title>
    </v-toolbar>

      <v-card-title>
        <v-form class="flex">
            <v-layout row wrap justify-start>
              <v-flex xs12 sm6 md4 xl3 class="pa-1">
                <v-select
                  v-model="chartFilter.distance"
                  :items="allRaceDistanceStringsOptions"
                  label="Dystans"
                  @change="refreshChart"
                  @input="refreshChart"
                  clearable
                ></v-select>
              </v-flex>
              <v-flex xs12 sm6 md4 xl3 class="pa-1">
                <v-menu
                  ref="menu1"
                  :close-on-content-click="false"
                  v-model="menu1"
                  :nudge-right="40"
                  :return-value.sync="chartFilter.start"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="chartFilter.start"
                    label="Data od"
                    prepend-icon="event"
                    readonly
                    clearable
                  @change="refreshChart"
                  @input="refreshChart"
                  ></v-text-field>
                  <v-date-picker v-model="chartFilter.start" @input="$refs.menu1.save(chartFilter.start)" no-title locale="pl"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12 sm6 md4 xl3 class="pa-1">
                <v-menu
                  ref="menu2"
                  :close-on-content-click="false"
                  v-model="menu2"
                  :nudge-right="40"
                  :return-value.sync="chartFilter.end"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="chartFilter.end"
                    label="Data do"
                    prepend-icon="event"
                    readonly
                    clearable
                  @change="refreshChart"
                  @input="refreshChart"
                  ></v-text-field>
                  <v-date-picker v-model="chartFilter.end" @input="$refs.menu2.save(chartFilter.end)" no-title locale="pl"></v-date-picker>
                </v-menu>
              </v-flex>

            </v-layout>
          </v-form>
      </v-card-title>
    <div v-if="showChart" class="chart-container">
      <results-chart :chart-data="chartData" :options="chartOptions" css-classes="chart-inner-container"></results-chart>
    </div>
  </v-card>
</div>
</template>

<script>
import {fetchRacesSimple} from '@/plan/api'
import { mapState, mapGetters } from 'vuex'
import _ from 'lodash'
import moment from 'moment'
import ResultsChart from './ResultsChart'
import Records from './Records'

export default {
  components: {ResultsChart, Records},
  data () {
    return {
      menu1: false,
      menu2: false,
      showChart: true,
      results: [],
      chartData: {},
      chartOptions: {
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            ticks: {
              reverse: true,
              suggestedMin: 0,
              suggestedMax: 10 * 60,
              callback: function (value, index, values) {
                let duration = moment.duration(value, 'seconds')
                return moment.utc(duration.as('milliseconds')).format('HH:mm:ss')
              }
            },
            gridLines: {
              color: '#80cbc4',
              zeroLineColor: '#80cbc4'
            }
          }],
          xAxes: [{
            gridLines: {
              color: '#80cbc4'
            }
          }]
        },
        legend: {
          display: false
        },
        tooltips: {
          callbacks: {
            label: function (tooltipItem, data) {
              let label = data.datasets[tooltipItem.datasetIndex].label || ''
              if (label) {
                label += ': '
              }
              let value = tooltipItem.yLabel
              let duration = moment.duration(value, 'seconds')
              label += moment.utc(duration.as('milliseconds')).format('HH:mm:ss')
              return label
            }
          }
        }
      },
      chartFilter: {
        distance: null,
        start: null,
        end: null
      }
    }
  },
  computed: {
    ...mapState(['runner']),
    ...mapGetters(['allRaceDistanceStringsOptions'])
  },
  created () {
    this.refetchView()
  },
  watch: {
    '$route': 'refetchView'
  },
  methods: {
    setDistance (distance) {
      this.chartFilter.distance = distance
      this.refreshChart()
    },
    refreshChart: _.debounce(function () {
      this.fetchResultsChart()
    }, 400),
    refetchView () {
      this.fetchResultsChart()
    },
    fetchResultsChart () {
      let params = {done: true}
      if (this.chartFilter.distance) {
        params['distance_string'] = this.chartFilter.distance
      } else {
        this.chartData = {}
        return
      }
      if (this.chartFilter.end) {
        params['race_date__lte'] = this.chartFilter.end
      }
      if (this.chartFilter.start) {
        params['race_date__gte'] = this.chartFilter.start
      }
      let promise = fetchRacesSimple(this.runner, params)
      return promise.then((data) => {
        let labels = []
        let times = []
        this.results = data
        let min = 60 * 60 * 60
        let max = 0
        for (let race of data) {
          labels.push(moment(race.race_date).format('DD-MM-YYYY'))
          let timeSeconds = moment.duration(race.time).asSeconds()
          times.push(timeSeconds)
          min = Math.min(timeSeconds, min)
          max = Math.max(timeSeconds, max)
        }
        if (min > max) {
          min = 0
        }
        let eps = (max - min) / 5
        min = Math.max(min - eps, 0)
        max = max + eps > 0 ? max + eps : 60 * 10

        this.chartData = {
          labels: labels,
          datasets: [
            {
              label: 'Czas',
              backgroundColor: '#f87979',
              borderColor: '#f87979',
              data: times,
              fill: false,
              lineTension: 0
            }
          ]
        }
        this.chartOptions.scales.yAxes[0].ticks.suggestedMin = min
        this.chartOptions.scales.yAxes[0].ticks.suggestedMax = max
        this.showChart = true
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/results/Results.vue